const NUMBER = new Intl.NumberFormat('en-US');

export function formatCount(value: number | null | undefined): string {
  return value == null ? '—' : NUMBER.format(value);
}

export function describeItems(items: number | null | undefined, failed: number | null | undefined): string {
  if (items == null) {
    return '—';
  }

  const label = `${formatCount(items)} ${items === 1 ? 'item' : 'items'}`;
  return failed ? `${label} · ${formatCount(failed)} failed` : label;
}

export function hasItemCounts(steps: ReadonlyArray<{ items: number | null }>): boolean {
  return steps.some((step) => step.items != null);
}
